import React, { Component, createElement } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { ComponentsManager, services, actions, EntitiesManager } from '@comall-backend-builder/core';
import { SSOLoader } from '../../loaders/session-loader';
import { getUrlParam } from '../../services/utils';
import { errorHandle } from '../../services/error-handle';

class customAuthentication extends Component<any, any> {
    componentWillMount() {
        let t = getUrlParam(window.location.href, 't');
        let u = getUrlParam(window.location.href, 'u');
        let c = getUrlParam(window.location.href, 'c');
        if (t && u && c) {
            // 免密登录
            SSOLoader.get(
                {
                    t,
                    u,
                    c
                },
                {
                    apiPath: '/sso_login',
                    apiRoot: ENV.API_ROOT,
                }
            )
                .then((res: any) => {
                    this.props.login(res);
                })
                .catch((e: any) => {
                    errorHandle(e);
                    setTimeout(() => {
                        this.props.logout();
                    }, 1000);
                });
        } else if (!services.privilege.hasPrivilege()) {
            setTimeout(() => {
                this.props.logout();
            });
        }
    }

    render() {
        const { content: { component } } = this.props;

        return createElement(ComponentsManager.get(component), this.props)
    }
}
export const CustomAuthentication = connect(
    null,
    (dispatch, _props: any) => {
        return {
            // 自动登录
            login: (user: any) => {
                const entity = new (EntitiesManager.get('privileges'))({});
                dispatch(actions.loginSuccessAction(user));
                dispatch(actions.getPrivilegeAction(entity, user));
            },

            // 重置 url
            logout: () => {
                window.location.href = ENV.REDIRECT_URI + '/#/login';
            }
        };
    }
)(customAuthentication);
